import React, { useEffect, useState } from 'react';
import { Alert, Button, FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import api from '../../../api/api';

export default function HomeEventVisibilityControl() {
  const [enabled, setEnabled] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const load = async () => {
    setBusy(true);
    setError('');
    try {
      const response = await api.getAuth('/admin/ads/events/home');
      if (typeof response.data?.data?.enabled !== 'boolean') throw new Error('Invalid settings');
      setEnabled(response.data.data.enabled);
      setLoaded(true);
    } catch {
      setError('홈 이벤트 노출 설정을 불러오지 못했습니다.');
    } finally {
      setBusy(false);
    }
  };
  useEffect(() => {
    void load();
  }, []);
  const toggle = async (next) => {
    setBusy(true);
    setError('');
    try {
      const response = await api.putAuth('/admin/ads/events/home', { enabled: next });
      if (typeof response.data?.data?.enabled !== 'boolean') throw new Error('Invalid settings');
      setEnabled(response.data.data.enabled);
    } catch {
      setError('홈 이벤트 노출 설정을 저장하지 못했습니다. 다시 시도해주세요.');
    } finally {
      setBusy(false);
    }
  };
  return (
    <Stack spacing={1} sx={{ p: 2, border: 1, borderColor: 'divider', borderRadius: 1 }}>
      <FormControlLabel
        label="홈에 이벤트 섹션 표시"
        control={
          <Switch
            checked={enabled}
            disabled={!loaded || busy}
            onChange={(event) => void toggle(event.target.checked)}
          />
        }
      />
      <Typography variant="body2" color="text.secondary">
        공개 이벤트를 홈에서 좌우로 넘겨 볼 수 있게 표시합니다. 끄더라도 이벤트 및 공지사항의 목록과
        개별 이벤트 공개 설정은 유지됩니다. 공개 이벤트가 없으면 홈에는 표시되지 않습니다. 앱에서는
        홈 새로고침 후 반영됩니다.
      </Typography>
      {busy && <Typography variant="caption">설정 반영 중…</Typography>}
      {error && (
        <Alert
          severity="error"
          action={
            !loaded ? (
              <Button onClick={load} disabled={busy}>
                재시도
              </Button>
            ) : undefined
          }
        >
          {error}
        </Alert>
      )}
    </Stack>
  );
}
